// @flow

export const SHORT_TABLE_ITEMS_COUNT = 5
export const SHORT_TILE_ROW_ITEMS_COUNT = 4
